var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":"","allow-overflow":true},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({class:_vm.iconColor,attrs:{"size":"22"}},'v-icon',attrs,false),on),[_vm._v(_vm._s(_vm.iconName))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.statusDescription))])])
}
var staticRenderFns = []

export { render, staticRenderFns }